<template>
  <div>
    <v-dialog
      @keydown.esc="dialog=false"
      max-width="500"
      v-model="dialog"
      persistent>
      <v-card>
        <v-card-title>
          <div class="d-flex">
            <div class="primary--text">
              Facturas de order de compra: {{ order.uuid }}
            </div>
            <v-spacer />
            <v-btn
              color="black darken-1"
              @click="close"
              text
              icon>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-form v-model="form.isValid" ref="form">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12 class="d-flex align-center">
                  <v-file-input
                    v-model="form.data.xmlFiles"
                    multiple
                    label="XML File"
                    accept=".xml"
                    :rules="rules.xmlFiles"
                    required>
                  </v-file-input>
                </v-flex>
                <v-flex xs6 sm6 md6 class="d-flex align-center justify-end">
                  <v-btn
                    color="success"
                    rounded
                    @click="viewInvoice">
                    Subir factura y revisar
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <InvoicePreview
      :isOpenDialog.sync="invoicePreviewOpen"
      :order="order"
      :data="data"
      :xmlFiles="form.data.xmlFiles"
      :key="order.id"
      @close="invoicePreviewOpen = false"
      @uploaded="close"/>

    <v-overlay :value="overlay" z-index="999999999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import InvoicePreview from '@/components/modals/InvoicePreview'

export default {
  name: 'Bill',
  props: ['dialog', 'order'],
  components: {
    InvoicePreview
  },
  data () {
    return {
      overlay: false,
      invoicePreviewOpen: false,
      data: [],
      form: {
        isValid: false,
        data: {
          xmlFiles: []
        }
      },
      rules: {
        xmlFiles: [(v) => v.length > 0 || 'Required']
      }
    }
  },
  methods: {
    viewInvoice: async function () {
      this.$refs.form.validate()

      if (this.form.isValid && this.order) {
        this.overlay = true
        try {
          const response = await this.$api.post(`/v1/orders/${this.order._id}/preview`, this.form.data, { delivery: 'formData' })
          this.data = response
          this.invoicePreviewOpen = true
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    close () {
      this.$refs.form.reset()
      this.form.data = { xmlFiles: [] }
      this.$emit('close')
    }
  }
}
</script>
